import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to="/auth" />)} />;
};

const mapStateToProps = state => state;

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProtectedRoute);
